import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {createForm} from 'core/form/createForm';
import {FormProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {IsNumber} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {Invoice} from "invoice/domain/invoiceDomain";
import {action} from "mobx";
import {observer} from "mobx-react";
import {PARTYROLE} from "party/partyDomain";
import commonService from "core/common/service/commonService";
import {GridRow} from "core/grid/domain/grid";
import {LovItem} from "../../core/metamodel/mdEntity";
import securityService from "core/security/securityService";
import {RESTRICTION} from "core/security/securityDomain";


interface InvoiceFormProps extends FormProps<Invoice, Invoice> {
  recalculate: (rootObject: Invoice, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: {[key: string]: any}) => Promise<any>;
}


@createForm({
  formName: 'InvoiceForm',
  fields: [{
    name: 'profitCenter',
  }, {
    name: 'paymentCond'
  }, {
    name: 'paymentType',
    validators: ['IsRequired']
  }, {
    name: 'invoiceCurrency',
    validators: ['IsRequired']
  }, {
    name: 'language',
    validators: ['IsRequired']
  }, {
    name: 'exchangeRate',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'invoiceAdjustmentKoef',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'issuedBy'
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'sendType',
    validators: ['IsRequired']
  }]
}, () => <noscript/>)
@observer
export default class InvoiceForm extends React.Component<InvoiceFormProps, undefined> {



  @action onInvoiceCurrencySuccess = () => {
    let {dataObject, form} = this.props;

    if (dataObject.invoiceCurrency && dataObject.localCurrency) {
      return this.props.recalculate(this.props.dataObject, null,null, {invoiceCurrencyChange: true})
        .then(() => {
          form.updateFieldsPropValue(dataObject, "exchangeRate");
          if (dataObject.getTuple("invoiceCurrencyChange")) {
            commonService.notifyInfo("Exchange rate has changed");
          }
        });
    } else {
      dataObject.exchangeRate = null;
      form.updateFieldsPropValue(dataObject, "exchangeRate");
    }

  };

  @action recalculate = (evt?: any) => {
    return this.props.recalculate(this.props.dataObject, null, null);
  };


  render() {

    let {dataObject, rootObject, entities, formName} = this.props;
    let {profitCenter, paymentCond, paymentType, invoiceCurrency, language, exchangeRate, comment, issuedBy, sendType,
      invoiceAdjustmentKoef} = dataObject.getFormFields(formName);

    let profitCenterOptions = (securityService.currentUser.hasRestriction(RESTRICTION.LIMIT_INVOICE_BY_USER_PROFITCENTER)) ?
      profitCenter.props.options.filter(lv => securityService.restrictionData.userProfitCenterIds.includes(lv.value)) : profitCenter.props.options;

    return (
      <BlockComp>

          {/*  2. row  */}
          <div className="row">
            <div className="fx col-xs-4">
              <StyledSelect {...profitCenter.props} options={profitCenterOptions} />
              <Validate field={profitCenter} value={profitCenter.props.value}/>
            </div>
            <div className="fx col-xs-4">
              <StyledSelect {...invoiceCurrency.props} />
              <Validate field={invoiceCurrency} value={invoiceCurrency.props.value} onSuccess={this.onInvoiceCurrencySuccess}/>
            </div>
            { (dataObject.invoiceIsCurrencyDifferent()) ? (
              <div className="fx col-xs-4">
                <NumberField {...exchangeRate.props}/>
                <Validate field={exchangeRate} value={exchangeRate.props.value} onSuccess={this.recalculate}/>
              </div>
            ) : null}
          </div>

          <div className="row">
            <div className="fx col-xs-4">
              <StyledSelect {...paymentType.props} />
              <Validate field={paymentType} value={paymentType.props.value}/>
            </div>
            <div className="fx col-xs-4">
              <StyledSelect {...paymentCond.props} />
            </div>
            <div className="fx col-xs-4">
              <StyledSelect  {...issuedBy.props} async loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.USER_ROLE]})}
                                                 clearable asterixForAll />
            </div>
          </div>


          <div className="row">
            <div className="fx col-xs-4">
              <NumberField {...invoiceAdjustmentKoef.props} />
              <Validate field={invoiceAdjustmentKoef} value={invoiceAdjustmentKoef.props.value} onSuccess={this.recalculate}/>
            </div>
            <div className="fx col-xs-4">
              <StyledSelect {...language.props} />
              <Validate field={language} value={language.props.value}/>
            </div>
            <div className="fx col-xs-4">
              <StyledSelect {...sendType.props} />
              <Validate field={sendType} value={sendType.props.value}/>
            </div>
          </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={1}  />
          </div>
        </div>

      </BlockComp>
    );
  }
}





// WEBPACK FOOTER //
// ./src/invoice/component/invoiceForm.tsx